<template>
	<div>
    <el-button @click="addKey()">添加</el-button>
    <div v-for="(item, index) in keyData" class="m-t-10">
      <el-select v-model="item.field_name" placeholder="请选择字段" class="w-150" @change="fieldNameChange(item)">
        <el-option
          v-for="field in keyList"
          :label="field.field"
          :value="field.field">
          {{field.field}}-{{field.title}}
        </el-option>
      </el-select>
      <el-input v-model="item.show_name" class="w-110 m-l-5"></el-input>
      <el-button type="danger" class="m-l-5" @click="deleteKey(index)">删除</el-button>
    </div>
  </div>
</template>
<script>
import http from '../../../assets/js/http'
export default {
  name: 'foreignConfig',
  props: {
    keyData: {
      type: Array,
      default() {
        return []
      }
    },
    keyList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      obj: {
        field_name: '',
        show_name: ''
      }
    }
  },
  methods: {
    addKey() {
      let newObj = _.cloneDeep(this.obj)
      this.keyData.push(newObj)
    },
    deleteKey(index) {
      this.keyData.splice(index, 1)
    },
    fieldNameChange(item) {
      // if (item.show_name) {
      //   return
      // }
      _(this.keyList).forEach((res) => {
        if (res.field == item.field_name) {
          item.show_name = res.title
          return false
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// foreignConfig.vue?6c51d231